import styled from 'styled-components';

export const TasksPreviewStyle = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  position: relative;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(157, 157, 157, 0.5);

    .heading-box {
      position: relative;
      font-size: 13px;
      line-height: 16px;
      max-width: 400px;
      color: var(--light-gray);
      padding: 0 0 0 30px;

      .btn-back {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        font-size: 25px;
        line-height: 1;
        cursor: pointer;
        color: var(--text-color-50);
      }
    }

    .heading {
      display: block;
      font-size: 20px;
      line-height: 24px;
      color: var(--dark-gray);
      color: var(--text-color-50);
      margin: 0 0 5px;

      span {
        font-weight: 400;
      }
    }

    .text {
      display: block;
    }
  }

  .content-holder {
    display: flex;
    gap: 20px;
  }

  .sidebar {
    flex-shrink: 0;
    width: 330px;
    height: calc(100vh - 170px);
    overflow-y: auto;
    padding-right: 10px;
    border-right: 1px solid rgba(157, 157, 157, 0.3);

    .filter-text {
      display: block;
      font-size: 13px;
      line-height: 16px;
      color: var(--light-gray);
      margin: 0 0 10px;
    }

    .filter-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 5px 0;
        border-bottom: 1px solid rgba(157, 157, 157, 0.3);

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          line-height: 17px;
          color: var(--text-color-50);
          text-decoration: none;
          padding: 5px 0;

          img {
            display: block;
            width: 20px;
            height: auto;
          }
        }
      }
    }
  }
  .table-holder {
    flex-grow: 1;
    height: calc(100vh - 170px);
    padding: 0 10px 10px 0;
    overflow-x: auto;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgba(157, 157, 157, 0.3);
    }
    .scroll-content {
      width: 1600px;
    }
    table {
      width: 100%;

      th,
      td {
        text-align: left;
        border-left: 1px solid rgba(157, 157, 157, 0.3);
        width: 100px;
        max-width: 300px;

        &:first-child {
          border-left: none;
        }

        > span {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      td {
        padding: 13px 10px;
      }
    }
  }
`;

export const FilterSelectStyle = styled.div`
  position: relative;
  width: 100%;
  padding: 10px 10px;
  font-size: 14px;
  line-height: 17px;
  color: var(--text-color-50);
  border-bottom: 1px solid rgba(157, 157, 157, 0.5);

  &.active {
    .filter-wrapper {
      display: flex;
    }
  }

  .filter-opener {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    cursor: pointer;
    color: var(--text-color-50);
  }

  .filter-wrapper {
    display: none;
    align-items: center;
    gap: 10px;
    padding: 10px 0 0;
  }

  .select-wrap {
    display: flex;
    align-items: center;
    height: 35px;
    border: 1px solid rgba(157, 157, 157, 0.2);
    border-radius: 6px;
    position: relative;

    &.select-active {
      .custom-option {
        display: block;
      }
    }

    .text-input {
      width: 106px;
      height: 100%;
      outline: none;
      border: none;
      padding: 5px;
    }

    .add-icon {
      width: 30px;
      height: 100%;
      background: var(--success);
      color: var(--white);
      border-radius: 0 6px 6px 0;
    }
  }

  .selected-options {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 10px 0 0;
  }

  .selected-option {
    display: inline-flex;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    gap: 3px;
    padding: 3px 5px;
    border-radius: 5px;
    color: var(--white);
    background: var(--success);
  }
  .icon {
    display: block;
    cursor: pointer;
  }

  .filter-select {
    width: 126px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    background: #f1f1f1;
    border-radius: 6px 6px 0 0;
    cursor: pointer;
    padding: 5px;
  }

  .custom-option {
    display: none;
    position: absolute;
    width: 150px;
    padding: 5px;
    border: 1px solid rgba(157, 157, 157, 0.2);
    border-radius: 5px;
    background: var(--white);
    margin-top: 5px;
    z-index: 1;

    .option-text {
      display: block;
      cursor: pointer;
      font-size: 13px;
      line-height: 16px;
      padding: 8px;
      margin: 0 -5px 0;
      &:hover {
        background: var(--primary-100);
      }
      .icon {
        display: none;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
